import PayoffDetails from './PayoffDetails';

export default PayoffDetails;
